import React from 'react';
import './LegalPages.css';

function Datenschutz() {
  return (
    <div>
      <section className="legal-hero">
        <h1>Datenschutzerklärung</h1>
      </section>
      <div className="legal-page">
        <h2>1. Datenschutz auf einen Blick</h2>
        <h3>Allgemeine Hinweise</h3>
        <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
        <h2>2. Datenerfassung auf dieser Website</h2>
        <h3>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h3>
        <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
        <h3>Verantwortliche Stelle</h3>
        <p>
          Verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br />
          Vorpoint<br />
          Ahmed Tahhan<br />
          Gorkistraße 84<br />
          04347 Leipzig<br />
          Telefon: +49-1778663796<br />
          E-Mail: info@vorpoint.de
        </p>
        <h3>Wie erfassen wir Ihre Daten?</h3>
        <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
        <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.</p>
      </div>
    </div>
  );
}

export default Datenschutz;